import { useEffect, useState } from "react";

export default function TextFeildWithSelect({ value,selectvalue,list,placeholder="", lableValue,lableKey, onChange, onSelectChange, label, selecterror,inputerror,required,disabled}) {

  const errorMsg = selecterror||inputerror

  return (
    <div className="UI-form-group">
      <label className={`UI-label ${errorMsg && "!tw-border-[#ff0000]"}`}>{label}{required && <sup>*</sup>}</label>
      <div className="tw-flex">
        <input
        type="text"
        value={value}
        onChange={onChange}
        className={`UI-input col-md-9 focus:!tw-border-[#3574de] !tw-rounded-r-none ${inputerror && "!tw-border-[#ff0000]"}`}
        placeholder={placeholder}
      />
        <select
        value={selectvalue}
        onChange={onSelectChange}
        disabled={disabled}
        className={`UI-input col-md-3  focus:!tw-border-[#3574de] !tw-rounded-l-none ${selecterror && "!tw-border-[#ff0000]"}`}  
      >
        {list.map((e, i) => (
          <option key={i} value={lableValue ? e[lableValue] : e} style={{ lineHeight: '1.8' }}>
            {lableKey ? e[lableKey] : e}
          </option>
        ))}
      </select>
      
      </div>
      {errorMsg && <div>
        <p className="tw-text-[10px] tw-text-[#ff0000] m-0 tw-pt-0.5 tw-pl-1">{errorMsg}</p>
      </div>}
    </div>
  );
}
